/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import S from './DatePicker.styles';
import addBusinessDays from 'date-fns/addBusinessDays';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import addYears from 'date-fns/addYears';
import isEqual from 'date-fns/isEqual';
const NewDatePicker = (props) => {
    const [start, setStart] = useState(props.startDate);
    const [end, setEnd] = useState(props.endDate);
    const containerRef = useRef(null);
    const readOnly = props.readOnlyInputs === true || props.readOnlyInputs === undefined;
    const minDate = useMemo(() => {
        if (props.leadTimeDays === undefined) {
            return addYears(new Date(), -5);
        }
        if (props.leadTimeDays === 0) {
            return new Date();
        }
        const minDate = addBusinessDays(new Date(), props.leadTimeDays + 1);
        return minDate;
    }, [props.leadTimeDays]);
    const handleChange = (dates) => {
        const [start, end] = dates;
        if (props.selectsEnd) {
            if (end !== null) {
                setStart(start);
                setEnd(end);
            }
            else {
                setEnd(start);
            }
            return;
        }
        setStart(start);
        setEnd(end);
    };
    useEffect(() => {
        if (start !== null && !isEqual(props.startDate, start)) {
            props.onStartDateChanged(start);
        }
        if (end !== null && !isEqual(props.endDate, end)) {
            props.onEndDateChanged(end);
        }
    }, [start, end]);
    const filterDate = (date) => {
        const day = date.getDay();
        const isWeekend = day === 0 || day === 6;
        if (isWeekend) {
            return false;
        }
        if (props.selectsEnd === true && props.startDate !== null) {
            return !isBefore(date, props.startDate);
        }
        if (props.excludedDates) {
            for (const excludedDate of props.excludedDates) {
                const startDate = excludedDate.isRecurring
                    ? new Date(excludedDate.startDate).setFullYear(date.getFullYear())
                    : new Date(excludedDate.startDate);
                const endDate = excludedDate.isRecurring
                    ? new Date(excludedDate.endDate).setFullYear(date.getFullYear())
                    : new Date(excludedDate.endDate);
                if (!isBefore(date, startDate) && !isAfter(date, endDate)) {
                    return false;
                }
            }
        }
        return true;
    };
    return (React.createElement(S.Wrapper, { ref: containerRef },
        React.createElement(S.LabelText, null,
            React.createElement("div", null, props.label)),
        React.createElement(DatePicker, { dateFormat: 'MMM d, yyyy', selectsRange: true, startDate: start, endDate: end, minDate: minDate, selectsEnd: props.selectsEnd, onChange: handleChange, filterDate: filterDate, inline: props.inline, maxDate: addYears(new Date(), 5) })));
};
function isDateRange(date) {
    return date.length !== undefined;
}
export default NewDatePicker;
